'use client'
import { cn, formatTime } from "@/lib/utils"
import { memberButtonVariants } from "../fun-ui/MemberButton"
import { VipLogoLightIcon, XCircleIcon } from "../fun-ui/icons"
import { useUserVip } from "@/stores/appStore";
import { VariantProps } from "class-variance-authority";
import { useUpgradeVip } from "./UpgradeVipButton";
import { Button } from "../fun-ui/Button";
import { useRenewalSonnerOpen } from "@/stores/localStore";
import { MemberPlanText } from "./MemberPlanText";

export interface RenewalSonnerProps
  extends React.ButtonHTMLAttributes<HTMLDivElement>,
  VariantProps<typeof memberButtonVariants> {
  activedPrice?: number;
}
export const RenewalSonner = ({
  className,
  activedPrice,
  ...props
}: RenewalSonnerProps) => {
  const { upgradeVip } = useUpgradeVip();
  const { vip, vipType, remainingDays, vipExtra } = useUserVip();
  const { open, setOpen } = useRenewalSonnerOpen();
  const handleClose = () => {
    setOpen(false);
  }
  if (!open) {
    return <></>;
  }
  if (vip !== 1) {
    return <></>;
  }
  if (!(typeof remainingDays === 'number' && remainingDays >= 0 && remainingDays <= 15)) {
    return <></>;
  }
  return (
    <div
      className={cn(
        "transition-all text-[#EDDBC0] bg-gradient-to-br from-[#a08669] to-[#553a20] ",
        "flex flex-row items-center h-[72px] rounded-xl px-6 gap-6",
        "absolute bottom-14 left-1/2 -translate-x-1/2 z-[32]",
        className,
      )}
      {
      ...props
      }
    >
      <VipLogoLightIcon size={36} />
      <div className="flex flex-col text-[#F0E1CB]">
        <span className="text-lg font-medium">{
          remainingDays > 0 ? (
            <MemberPlanText vip={vip} vipType={vipType} suffix={`仅剩 ${remainingDays} 天`} />
          ) : (
            <MemberPlanText vip={vip} vipType={vipType} suffix="今日到期" />
          )
        }</span>
        <span className="text-sm">会员有效期至：{formatTime(vipExtra?.expireTime!, 'YYYY-MM-DD')}</span>
      </div>
      <Button
        variant="ghost"
        className="bg-[#F0E1CB] text-[#593E23] hover:bg-[#F0E1CB]/90 hover:text-[#593E23]/90 h-[38px] w-[100px] font-medium text-base"
        onClick={() => {
          upgradeVip({
            activedPrice,
          });
        }}
      >立即续费</Button>
      <span onClick={handleClose}>
        <XCircleIcon className="cursor-pointer text-[#F0E1CB]/50 hover:text-[#F0E1CB]/70" fill="#593E23" size={20} />
      </span>
    </div>
  )
}